export default __webpack_public_path__ + "static/RootSans-12BlackItalic-e68ce128f8678c53df5d8b666e506a33.woff2";